<template>
  <div class="card-box" @click="goDetail()">
    <div class="card-pic">
      <div class="tips-tag" :class="statusColor">{{ tag }}</div>
      <el-image
        class="cover-photo"
        :src="cardData.live_cover"
        fit="cover"
      />
    </div>
    <div class="card-title">
      <h3>{{ cardData.title }}</h3>
    </div>
    <div class="time-info">
      <i class="el-icon-time" />
      <span>{{ cardData.live_time }}</span>
      <span class="view"><i class="el-icon-view" /> {{ cardData.view_count }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    tag() {
      switch (this.cardData.status) {
        case 2:
          return '未开始'
        case 3:
          return '直播中'
        case 1:
          if (this.cardData.review_url) {
            return '有回放'
          } else {
            return '已结束'
          }
        default:
          return ''
      }
    },
    statusColor() {
      switch (this.cardData.status) {
        case 1:
          return 'end-clor';
        case 2:
          return 'ready-clor';
        case 3:
          return 'living-clor';
        default:
          return 'end-clor';
      }
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: `/broadcast/detail/${this.cardData.id}`,
      })
    },
  },
}
</script>
<style lang="less" scoped>
.card-box {
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  background-color: #ffffff;

  .card-pic {
    width: 100%;
    height: 220px;

    .tips-tag {
      position: absolute;
      padding: 6px 12px;
      top: 18px;
      left: 18px;
      font-size: 16px;
      border-radius: 6px;
      color: #FFFFFF;
      z-index: 2;

      &.end-clor {
        background-color: #A0A0A0;
      }
      &.ready-clor {
        background-color: #24B9A7;
      }
      &.living-clor {
        background-color: #FFA600;
      }
    }

    .cover-photo {
      width: 100%;
      height: 100%;
    }
  }

  .card-title {
    padding: 16px 20px;
    border-top: 12px solid #66d5c8;

    h3 {
      height: 44px;
      font-size: 16px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      white-space: normal;
    }

    .title-tag {
      margin-top: 10px;
      width: fit-content;
      height: 24px;
      padding: 0 12px;
      font-size: 12px;
      background-color: #e4ebff;
      color: #3160f6;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
    }
  }

  .time-info {
    padding: 0 20px 16px;
    color: #787878;
    span{
      margin-left: 5px;
    }
    .view{
      float: right;
    }
  }
}
</style>
